module.exports = __webpack_public_path__ + "img/kakaopay.52d7bddf.png";